import { InputLabel } from '@material-ui/core'
import React from 'react'




export default function AlignItems({ styleAtual, value, onChange }) {


    return (
        <div className='OkStyleEditor-comp'>
            <InputLabel>Align Items</InputLabel>
            <div className='OkStyleEditor-row'>
                <button className={value === 'flex-start' ? 'OkStyleEditor-buttonSelected' : ''} onClick={() => onChange('flex-start')}>flex-start</button>
                <button className={value === 'center' ? 'OkStyleEditor-buttonSelected' : ''} onClick={() => onChange('center')}>center</button>
                <button className={value === 'flex-end' ? 'OkStyleEditor-buttonSelected' : ''} onClick={() => onChange('flex-end')}>flex-end</button>
                <button className={value === 'stretch' ? 'OkStyleEditor-buttonSelected' : ''} onClick={() => onChange('stretch')}>stretch</button>
            </div>

        </div>
    )
}
